/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersSkeleton.defs.js'
export { main as default } from './getSuggestedUsersSkeleton.defs.js'
